<template  >
  <!--Certificate Section 08 -->
  <div class="certificate course_list">
    <section class>
      <div class="container_1">
        <div class="row justify-content-center">
          <div class="col-lg-12 order-lg-2">
            <div class="hero-image">
              <h2>{{$root.certificate.text_cer}}</h2>
              <img class src="/assets/exported/certificate.jpg" alt />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="spinnerdes" v-if="isLoading">
        <div class="dot1"></div>
        <div class="dot2"></div>
      </div>
      <div class="container course_hero cer_hero" v-if="showCertificate != ''">
        <div class="course_list_menu">
          <img :src="showCertificate" width="80%" alt />
          <div class>
            <div class="row_course cer_center">
              <h2>{{$root.certificate_h.text_cer_h}}</h2>
              <div class="cer_button login-section">
                <a :href="downloadURL">
                  <button type="submit">{{$root.certificate_b.text_cer_b}}</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import axios from "axios";
export default {
  name: "",
  components: {},
  data() {
    return {
      showCertificate: "",
      downloadURL: "",
      isLoading: true,
    };
  },
  mounted() {
    this.reloadAPI();
  },
  methods: {
    reloadAPI() {
      var user_profile = JSON.parse(window.localStorage.getItem("profile"));
      var config = {
        headers: {
          "X-localization": this.$root.translate ? "bn" : "en",
          Authorization: "bearer " + user_profile.token,
        },
      };
      // this.$root.getSelectedCourse();
      var courseId = this.$root.getSelectedCourse();
      axios
        .get(
          this.$root.API_BASE_URL +
            "certificate-check?course_id=" + courseId,
          config
        )
        .then((response) => {
          // Response received From Server
          this.isLoading = false;

          console.log(response.data);

          if (response.data == []) {
            // Blank
            return;
          }

          if (response.data.code == 200) {
            this.showCertificate =
              this.$root.API_BASE_URL +
              "certificate-img?" +
              "course_id=" +
              courseId +
              "&token=" +
              user_profile.token;

            this.downloadURL =
              this.$root.API_BASE_URL +
              "certificate-img?" +
              "download=true&course_id=" +
              courseId +
              "&token=" +
              user_profile.token;
          } else {
            this.showCertificate = "";
          }
        });
    },
  },
};
</script>


<style scoped>
@media screen and (max-width: 768px) {
  .certificate .cer_hero h2 {
    font-size: 20px;
  }
}
@media screen and (max-width: 3100px) {
  .course_list .form-inline{
    left: 40%;
  }
  .course_list .hero-image h2{
    left: 45.5%;
  }
}
@media screen and (max-width: 1920px) {
   .course_list .form-inline{
    left: 42%;
  }
  .course_list .hero-image h2{
    left: 45.5%;
  }
}

@media screen and (max-width: 1440px) {
   .course_list .form-inline{
    left: 38%;
  }
   .course_list .hero-image h2{
    left: 42.5%;
  }
}
@media screen and (max-width: 1100px) {
   .course_list .form-inline{
    left: 35%;
  }
   .course_list .hero-image h2{
    left: 40.5%;
  }
}
@media screen and (max-width: 1023px) {
   .course_list .form-inline{
    left: 32%;
  }
   .course_list .hero-image h2{
    left: 40%;
  }
}
@media screen and (max-width: 990px) {
  .spinner {
    margin: 100px 170px;
    margin-top: 40px;
  }
   .course_list .form-inline{
    left: 30%;
  }
}
@media screen and (max-width: 768px) {
  .course_list_menu {
    width: 100%;
  }
   .course_list .form-inline{
    left: auto;
  }
  .course_list .hero-image h2{
    left: auto;
  }
}
@media screen and (max-width: 480px) {
  .course_list_menu {
    width: 100%;
  }
  .course_hero h2 {
    font-size: 24px;
    padding-bottom: 20px;
  }
}
</style>